<template>
	<div class="associate">
		<slot />
		<div class="associateBg" v-if="associateKey && associateList?.length > 0" @click.stop="associateKey = false"></div>
		<ul class="associateList" v-if="associateKey && associateList?.length > 0">
			<li
				v-for="(item, index) in associateList"
				:key="index"
				v-html="$highlight(item?.Name || ``, details?.company)"
				@click.stop="checkCompany(item?.Name || ``, index)"
			></li>
		</ul>
	</div>
</template>

<script>
/** 防抖
 * @param fn 业务逻辑函数
 * @param time 延迟时间
 */
const debounce = (fn, time = 500) => {
	let timer;
	return function (...args) {
		const context = this;
		clearTimeout(timer);
		return new Promise((resolve, reject) => {
			timer = setTimeout(() => {
				fn.apply(context, args).then(resolve).catch(reject);
			}, time);
		});
	};
};
export default {
	props: {
		formData: {
			typeof: Object,
			default: {}
		}
	},
	watch: {
		formData(newVal) {
			this.details = newVal;
		}
	},
	data() {
		return {
			details: {},
			associateKey: false,
			associateList: []
		};
	},
	mounted() {
		this.details = this.formData;
	},
	methods: {
		queryCompany(searchName) {
			this.associateKey = true;
			this.inquireCompany(searchName)
				.then((res) => {
					if (res?.Result?.VerifyResult == 1) {
						this.associateList = res?.Result?.Data || [];
					} else {
						this.associateList = [];
					}
				})
				.catch((err) => {
					console.error(err);
					this.associateList = [];
				});
		},
		checkCompany(item, index) {
			this.$emit('check', item);
			this.$nextTick(() => {
				this.associateKey = false;
			});
		},
		$highlight(title, highlight) {
			function escapeRegExp(string) {
				// 转义用于正则表达式的特殊字符
				return String(string).replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
			}

			if (!highlight || !title) {
				// 如果没有提供突出显示词或标题，则返回原始标题
				return title;
			}

			// 创建一个不区分大小写的正则表达式，以查找高亮显示的术语的所有出现
			const reg = new RegExp(escapeRegExp(highlight), 'gi');
			// 用高亮显示的版本替换标题中找到的术语
			// 在App.vue中定义class highlight
			return title.replace(reg, `<span>$&</span>`);
		},
		inquireCompany: debounce(function (keyword) {
			return this.$http
				.get('/api/platform/send/getlist', {
					params: { searchName: keyword }
				})
				.then((res) => res.data)
				.catch((err) => {
					console.error(err);
					throw err;
				});
		}, 500)
	}
};
</script>

<style scoped lang="less">
.associate {
	position: relative;

	.associateBg {
		position: absolute;
		width: 100vw;
		height: 100vh;
		left: 0;
		top: 0;
		z-index: 90;
	}

	.associateList {
		position: absolute;
		top: 100%;
		left: 0;
		z-index: 100;
		width: 100%;
		border-radius: 8px;
		box-shadow: 0 0 12px 6px rgba(0, 0, 0, 0.15);
		background-color: #fff;

		li {
			padding: 20px;
			border-bottom: 1.5px solid rgba(0, 0, 0, 0.1);
			font-size: 28px;
			white-space: pre-wrap;
			word-wrap: break-word;
			word-break: break-word;

			&:last-child {
				border: none;
			}

			span,
			/deep/span {
				color: #991d85;
			}
		}
	}
}
</style>
